var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var S3Credentials_1;
import { JSON, JsonDiscriminatorValue, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import { Credentials, CredentialsType } from '@symon-ai/wisepipe-common';
import { s3CredentialsSchemaValidation } from '../validations.generated';
export const s3CredentialsSchema = {
    $id: 'urn:wisepipe-common:S3Credentials',
    type: 'object',
    properties: {
        accessKey: { type: 'string', minLength: 1 },
        secret: { type: 'string', minLength: 1 },
        sessionToken: { type: 'string', minLength: 1 }
    },
    required: ['accessKey', 'secret']
};
// Special credential type for our transient external s3 parquet, and Incentives composer calculations for direct access to Incentives S3
// Equivalent to basically userPW or ApiKey
// accesskey+secret -> go to your users and generate credentials
// accesskey+secret+token -> run aws sts get-session-token, NOTE that the accesskey+secret you get back with the token are DIFFERENT
//		than the one you used in the original get-session-token command
let S3Credentials = S3Credentials_1 = class S3Credentials extends Credentials {
    constructor(accessKey, secret, sessionToken) {
        super(CredentialsType.S3Credentials);
        this.accessKey = accessKey;
        this.secret = secret;
        this.sessionToken = sessionToken;
        JSON.validate(this, S3Credentials_1);
    }
    async encrypt(encryptFn) {
        const enSessionToken = this.sessionToken ? await encryptFn(this.sessionToken) : this.sessionToken;
        const enAccessKey = await encryptFn(this.accessKey);
        const enSecret = await encryptFn(this.secret);
        return new S3Credentials_1(enAccessKey, enSecret, enSessionToken);
    }
    async decrypt(decryptFn) {
        const deSessionToken = this.sessionToken ? await decryptFn(this.sessionToken) : this.sessionToken;
        const deAccessKey = await decryptFn(this.accessKey);
        const deSecret = await decryptFn(this.secret);
        return new S3Credentials_1(deAccessKey, deSecret, deSessionToken);
    }
};
S3Credentials = S3Credentials_1 = __decorate([
    JsonSchemaV2(s3CredentialsSchema, s3CredentialsSchemaValidation),
    JsonDiscriminatorValue(CredentialsType.S3Credentials)
], S3Credentials);
export { S3Credentials };
//# sourceMappingURL=s3Credentials.js.map